var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-level1',_vm._b({scopedSlots:_vm._u([{key:"filters",fn:function(){return [_c('ui-filters',{attrs:{"actions":_vm.actions,"has-reset":false}})]},proxy:true}])},'layout-level1',_vm.attrs,false),[_c('div',{staticClass:"layout-level1__container"},[_c('data-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }